import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ctRcvKind } from "../../lib/classTalk/CodeEnum";

// 마지막 채팅 메시지의 미리보기 텍스트를 반환
const getLastChatPreviewText = (member, noHistoryText) => {
    const chatHistory = member.chat_history;
    if (!chatHistory || chatHistory.length === 0) return noHistoryText;

    const { msgInfo } = chatHistory[chatHistory.length - 1];

    if (msgInfo.rcvKind !== ctRcvKind.ContentSend) {
        return msgInfo.text;
    }

    const information = msgInfo.information || {};
    switch (information.contentType) {
        case "url-start":
            return information.url;
        case "file-upload":
            return information.originalFileName;
        case "message":
            return information.message;
        case "app-start":
            return information.appName;
        default:
            return information.url;
    }
};

const GroupChatList = ({ list_groupChat, handleSelectedGroupChatFunc }) => {
    const { t } = useTranslation();

    const [history, setHistory] = useState([]);

    useEffect(() => {
        console.log("group chat list - ", list_groupChat);
        setHistory(list_groupChat);
    }, [list_groupChat]);
    
    return (
        <div className="pbl-group-chat-list pbl-dark-scroll" style={{ overflow: 'auto' }}>
            {
                history && history.length > 0 ?
                <div className="list-group scroll-show-active pbl-dark-scroll" style={{ height: '100%', overflow: 'auto' }}>
                    {
                        history.map((member, index) => (
                            <div className={"d-flex list-group-hitem list-group-hitem-action p-2 justify-content-center align-items-center" + (member.userJoinStatus === "Y" ? " login" : "")} key={'member-' + index} onClick={() => handleSelectedGroupChatFunc({ selectedFunc: "OPEN_PER_CHAT", userSeq: member.userSeq })}>
                                <div className="d-flex text-area flex-column align-items-start px-1">
                                    <span className="hiclass-text" style={{ fontWeight: 400 }}>{member.userNickname}</span>
                                    <span className={"hiclass-text small" + (member.userJoinStatus === "Y" ? " white-text" : " grey-text")}>
                                    {
                                        getLastChatPreviewText(member, "메시지가 없습니다.")
                                    }
                                    </span>
                                </div>
                            </div>
                        ))
                    }
                </div> :
                <div className="view p-2 text-center grey-text">
                    {t("클래스_알림_메시지_2", { ns: "live" })}
                </div>
            }
        </div>
    );
}

export default GroupChatList;